import { currentDomain as CURRENT_DOMAIN } from '@bfe/by-dynamic-domain';

/**
 * 解析 URL 白名单属性
 *
 * @param  {Object} data 数据源
 * @return {Object}
 */
export const parseUrlProps = (data = {}) => {
    const mapping = {};
    const props = [
        'href',
        'origin',
        'protocol',
        'port',
        'host',
        'hostname',
        'search',
        'hash',
        'pathname',
    ];
    props.forEach((key) => {
        mapping[key] = data[key] || '';
    });

    return mapping;
};

/**
 * 解析链接字符为对象
 *
 * @param  {string} url 链接
 * @return {Object}
 */
export const parseUrl = (url = ''):any => {
    try {
        return new URL(url);
    } catch (e) {
        const a = document.createElement('a');
        a.href = url;
        return parseUrlProps(a);
    }
};

/**
 * 替换链接的主域为当前 location.hostname 的主域
 *
 * @param {string} url 需要替换的 url
 * @return {string} 替换后的 url
 */
export const replaceDomainToLocation = (url) => {
    // domainReg 解释
    // 匹配 url 中协议后面的第一个 `/` 或者 第一个`:端口号/` 前面的两个域。比如：
    // https://www.bybit.com/a 匹配到 bybit.com
    // https://m.www.bybit.com/a 匹配到 bybit.com
    // https://m.www.bybit.com:8080/a 匹配到 bybit.com
    // https://m.www.bybit-m.com:8080/a 匹配到 bybit-m.com
    const domainReg = /(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?){2}(?=(?::\d+)?\/)/;
    return url.replace(domainReg, `.${CURRENT_DOMAIN}`);
};

/**
 * 替换链接的s1域名为 当前hostname/bycsi-root 路径
 */
export const replaceS1DomainToLocation = (url) => {
    const domainReg = /s1\.bycsi\.com/;
    // return url.replace(domainReg, `${CURRENT_DOMAIN}/bycsi-root`);
    // 临时处理，防止testnet访问失败，之后替换成当前host+新path
    return url.replace(domainReg, `www.bybit.com/bycsi-root`);
}
